<template>
  <div class="grid-view">
    <div
      v-show="showMainList"
      class="main-content"
      type="primary"
    >
      <div style="height: auto;width: 100%;margin-top: 5px;" class="cargo-advance-search">
        <div v-show="showSimple" class="cargo-advance-search-header">
          <div class="cargo-advance-search-toggle-trigger">
            <i
              v-show="showAdv"
              class="el-icon-arrow-left"
              :style="{transform: !isShowingMoreSearchCondition?'rotate(-90deg)':'rotate(90deg)'}"
              @click="upOrDownSearchCondition"
            />
          </div>
          <div v-show="showSimple && !isShowingMoreSearchCondition" class="cargo-advance-search-quick">
            <!--清空时不需要弹出提示，只有输入框为空，点击查询时才需要弹出提示-->
            <!--@clear="simSearch"-->
            <el-input
              ref="keyword"
              v-model="keyWords"
              style="width:200px;"
              :placeholder="simQueryPlaceholder"
              :spellcheck="false"
              @blur="keyWordBlur"
              @keyup.enter.native.prevent="toQuery"
            />
          </div>
          <div ref="searchOperations" class="cargo-advance-search-operations">
            <slot name="operations">
              <!--页面操作按钮-->
              <div>
                <cargo-advance-select
                  v-if="!isShowingMoreSearchCondition"
                  style="width: 115px;display: inline-block;"
                  filterable
                  :disabled="disabled"
                  :clearable="false"
                  :default-value="filter.currency"
                  :select-type="selectTypeNames.basic_data_Currency"
                  @parentCallBack="changeCurrency"
                />
                <el-select
                  v-if="!isShowingMoreSearchCondition"
                  v-model="filter.level"
                  style="width:190px;display: inline-block;margin-left: 10px;"
                  @change="onLevelChanged"
                >
                  <el-option
                    v-for="(item,index) in tiers"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  />
                </el-select>
                <el-button style="margin-left: 10px" type="primary" :disabled="disabled" @click="toQuery">
                  {{ $t('CargoMsg.Cargo_Query') }}
                </el-button>
                <el-button type="primary" @click="resetSearch()">{{ $t('CargoMsg.Cargo_Reset') }}</el-button>
                <el-button type="primary" @click="onQuatotion()">{{ $t('Pricing.Quotation') }}</el-button>
                <el-button type="primary" @click="onSubscribe()">{{ $t('Pricing.Subscribe') }}</el-button>
                <el-button type="primary" @click="exportToExcel()">{{ $t('Pricing.Export') }}</el-button>
              </div>
            </slot>
          </div>
        </div>
        <slot name="searchAreaHeader">
          <!--搜索条件区域-头-->
        </slot>
        <div
          v-if="showAdv"
          v-show="isShowingMoreSearchCondition"
          class="section cargo-advance-search-more"
        >
          <div class="cargo-advance-search-more-operations">
            <div>
              <el-form label-width="80px" label-position="left" :inline="true">
                <el-radio-group v-model="rdoGroupOrg">
                  <el-radio label="pol">{{ $t('Pricing.POL') }}</el-radio>
                  <el-radio label="col">{{ $t('Pricing.COL') }}</el-radio>
                </el-radio-group>
                <cargo-advance-select
                  v-if="rdoGroupOrg === 'pol'"
                  filterable
                  :placeholder="$t('Pricing.POLPrompt')"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  style="width:190px;display: inline-block;margin-left: 10px;"
                  :default-value="filter.pol"
                  @parentCallBack="p=>{filter.pol=p.value}"
                />
                <cargo-advance-select
                  v-if="rdoGroupOrg === 'col'"
                  filterable
                  :placeholder="$t('Pricing.COLPrompt')"
                  :select-type="selectTypeNames.basic_data_Country"
                  style="width:190px;display: inline-block;margin-left: 10px;"
                  @parentCallBack="p=>{filter.col=p.value}"
                />
                <el-form-item :label="$t('Pricing.Carrier_Air')" style="margin-left: 10px;">
                  <cargo-advance-select
                    filterable
                    :select-type="selectTypeNames.basic_data_Company"
                    :method-params="{airCmp:true}"
                    :custom-label="(item)=>`[${item.shortName}]${item.chineseName}`"
                    :show-custom-label-in-option="true"
                    style="width:190px;"
                    @parentCallBack="p=>{filter.carrier=p.value}"
                  />
                </el-form-item>
                <el-form-item v-if="isManageModule || isShowCreatedBy" :label="$t('Pricing.CreatedBy')" style="margin-left: 10px;">
                  <cargo-advance-select
                    filterable
                    :select-type="selectTypeNames.basic_data_User"
                    :default-value="filter.createdBy"
                    :callback-params="{key:'userId'}"
                    style="width:190px;display: inline-block;margin-left: 10px;"
                    @parentCallBack="p=>{filter.createdBy=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('Pricing.Currency')" style="margin-left: 10px;">
                  <cargo-advance-select
                    style="width: 115px;"
                    filterable
                    :disabled="disabled"
                    :clearable="false"
                    :default-value="filter.currency"
                    :select-type="selectTypeNames.basic_data_Currency"
                    @parentCallBack="changeCurrency"
                  />
                </el-form-item>
              </el-form>
              <el-form label-width="80px" label-position="left" :inline="true">
                <el-radio-group v-model="rdoGroupDes">
                  <el-radio label="pod">{{ $t('Pricing.POD') }}</el-radio>
                  <el-radio label="cod">{{ $t('Pricing.COD') }}</el-radio>
                </el-radio-group>
                <cargo-advance-select
                  v-if="rdoGroupDes === 'pod'"
                  filterable
                  :placeholder="$t('Pricing.POLPrompt')"
                  :select-type="selectTypeNames.basic_data_Airport"
                  :custom-label="(item)=>`[${item.code}]${item.englishName}`"
                  :filter-tag-names="['code','englishName']"
                  :show-custom-label-in-option="true"
                  style="width:190px;display: inline-block;margin-left: 10px;"
                  @parentCallBack="p=>{filter.pod=p.value}"
                />
                <cargo-advance-select
                  v-if="rdoGroupDes === 'cod'"
                  filterable
                  :placeholder="$t('Pricing.COLPrompt')"
                  :select-type="selectTypeNames.basic_data_Country"
                  style="width:190px;display: inline-block;margin-left: 10px;"
                  @parentCallBack="p=>{filter.cod=p.value}"
                />
                <el-form-item :label="$t('Pricing.BeginDate')" style="margin-left: 10px;">
                  <el-date-picker
                    v-model="filter.beginDate"
                    type="date"
                    style="width:130px;margin-left:10px"
                    value-format="yyyy-MM-dd"
                  />
                  <span style="margin: 5px;">{{ $t('Pricing.EndDate') }}</span>
                  <el-date-picker
                    v-model="filter.endDate"
                    type="date"
                    style="width:130px;margin-left:10px"
                    value-format="yyyy-MM-dd"
                  />
                </el-form-item>
                <el-form-item v-if="showLevel" :label="$t('Pricing.Level')" style="margin-left: 10px;">
                  <el-select
                    v-model="filter.level"
                    style="width:190px;display: inline-block;margin-left: 10px;"
                    @change="onLevelChanged"
                  >
                    <el-option
                      v-for="(item,index) in tiers"
                      :key="index"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <el-form-item label="All In" style="margin-left: 10px;">
                  <el-checkbox v-model="filter.allIn" />
                </el-form-item>
              </el-form>
            </div>

          </div>
        </div>
      </div>

      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="23140103"
          :grid-params.sync="gridParams"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="rowData"
        />
      </div>
      <div ref="txtRemark" style="height: 6%; width: 99%" @dblclick="onTxtRemarksDoubleClick()">
        <textarea v-model="txtRemarks" :disabled="true" style="width: 100%; margin-left: 10px; height: 100%;" :title="$t('Pricing.RemarkAreaToolTip')" />
      </div>
    </div>
    <subscribe-dialog :visible="subscribe.visible" price-name="PA" :is-ar="true" @close="onSubscribeClose" />
    <el-dialog
      v-if="exportDialog.visible"
      v-el-drag-dialog
      :visible.sync="exportDialog.visible"
      :title="$t('Message.Prompt')"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="display: flex;flex-direction: column; text-align: center">
        <span style="line-height: 40px;">{{ $t('Pricing.ExportMode') }}？</span>
      </div>
      <div slot="footer" style="margin: 0 auto;width: fit-content;">
        <el-button type="primary" style="margin-right: 30px;" @click="exportAll()">{{ $t('Pricing.WYSIWYG') }}</el-button>
        <el-button type="primary" style="margin-right: 30px;" @click="ExportByTemplate()">{{ $t('Pricing.ExportByTemplate') }}</el-button>
        <el-button @click="exportDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getLoading } from '@/utils/utilBaseElement'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import cargoOfficeSelect from '@/components/Cargo/Common/cargoOfficeSelect'
import {
  queryPriceAirRealDetail,
  queryPriceAirRealSimplePriceNo,
  exportByTemplate
} from '@/api/price/priceAir'
import URL from '@/api/urlTranslator'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import { PricingAirConfigUtil } from '@/class/cargo/model/utils/PricingAirConfigUtil'
import SubscribeDialog from '@/views/cargo/v0/Price/PriceReal/components/PriceReal/SubscribeDialog'
import $store from '@/store'
import StrUtils from '@/utils/StrUtils'
import { TenantUtil } from '@/class/cargo/model/utils/TenantUtil'
import DateUtils from '@/utils/dateUtils'
import { exportExcel } from '@/utils/tableDataExportUtils'
import convertResToBlob from '@/utils/convertResToBlob'

export default {
  name: 'AirRealList',
  components: {
    SubscribeDialog,
    searchItem, cargoAdvanceSelect, cargoOfficeSelect
  },
  props: {
    showAdv: { type: Boolean, default: true }, // 显示高级查询
    expandAdv: { type: Boolean, default: false }, // 是否初始展开高级查询
    disabled: { type: Boolean, default: () => false }, // 禁用
    isShowCreatedBy: { type: Boolean, default: true },
    isManageModule: { type: Boolean, default: false },
    showSimple: { type: Boolean, default: true }, // 显示简单UI查询
    showCurrency: { type: Boolean, default: false },
    showCreate: { type: Boolean, default: false },
    showModify: { type: Boolean, default: false },
    showApprove: { type: Boolean, default: false }
  },
  data() {
    return {
      URL,
      proxy: {},
      creditInfoVisible: false,
      selectTypeNames: TYPE_NAMES,
      tiers: [],
      rdoGroupOrg: 'pol',
      rdoGroupDes: 'pod',
      rowData: [],
      tenantUtil: {},
      showLevel: false, // 是否显示运价等级
      authLevel: 99, // 是否显示运价等级
      txtRemarks: '',
      remarkChange: false,
      creditInfoList: [],
      citySeaport: ColumnUtils.getCitySeaport(),
      simQueryPlaceholder: this.$t('Pricing.priceNoPrompt'), // 快捷检索 占位符
      isAdvancedQuery: false, // 是否为高级查询
      isShowingMoreSearchCondition: this.expandAdv,
      filter: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        region: '',
        cityCode: '',
        opOffice: 0,
        carrier: 0,
        cmbCreatedBy: 'createdBy',
        txtBookingAgent: '',
        txtUnNo: '',
        level: '',
        currency: 'RMB',
        allIn: false,
        beginDate: DateUtils.formatStandardDate(new Date()),
        endDate: ''
      },
      filterJson: {},
      showDetail: false,
      keyWords: null,
      fullscreenLoading: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        onRowClicked: this.onRowClickedEvent
      },
      gridParams: {},
      gridApi: null,
      columnDefs: [
        {
          headerName: ' ', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Pricing.PriceNo'), field: 'priceNo', colId: 'priceNo', width: 200,
          tooltipValueGetter: (params) => {
            return PriceUtils.priceNoTipFunc(params.data, this.tenantUtil)
          } },
        {
          headerName: this.$t('Pricing.POL'), field: 'pol', colId: 'pol', width: 200,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value,
              'englishName')
          }
        }, { headerName: this.$t('Pricing.POD'), field: 'pod', colId: 'pod', width: 200,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value,
              'englishName')
          } },
        {
          headerName: this.$t('Pricing.Via'), field: 'via', colId: 'via', width: 200,
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Airport, 'code', params.value,
              'englishName')
          }
        },
        {
          headerName: this.$t('Pricing.Flight'), field: 'flight', colId: 'flight', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_PriceServiceAir, 'code', params.value,
              $store.getters.language === 'zh' ? 'chineseName' : 'englishName')
          }
        },
        {
          headerName: this.$t('Pricing.Aircraft'), field: 'aircraft', colId: 'aircraft', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.aircraftLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('Pricing.Currency'), field: 'currency', colId: 'currency', width: 200
        },
        {
          headerName: 'M', field: 'minCharge', colId: 'minCharge', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
          }
        },
        {
          headerName: 'N', field: 'step', colId: 'step', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
          }
        },
        { headerName: '+45', field: 'p45', colId: 'p45', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
          } },
        { headerName: '+100', field: 'p100', colId: 'p100', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
          } },
        { headerName: '+300', field: 'p300', colId: 'p300', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
          } },
        { headerName: '+500', field: 'p500', colId: 'p500', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
          } },
        { headerName: '+1000', field: 'p1000', colId: 'p1000', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.numberColumnLabelFunc_TACT(params, this.showCurrency, this.filter.currency, this.filter.allIn)
          } },
        { headerName: 'FSC', field: 'fsc', colId: 'fsc', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.convertCurrencyColumnLabelFunc(params, this.showCurrency, this.filter.currency)
          } },
        { headerName: 'SSC', field: 'ssc', colId: 'ssc', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.convertCurrencyColumnLabelFunc(params, this.showCurrency, this.filter.currency)
          } },
        { headerName: 'TC', field: 'tc', colId: 'tc', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.convertCurrencyColumnLabelFunc(params, this.showCurrency, this.filter.currency)
          } },
        { headerName: this.$t('Pricing.Carrier_Air'), field: 'carrier', colId: 'carrier', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company,
              'cmpIdx', params.value, 'shortName')
          },
          tooltipValueGetter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company,
              'cmpIdx', params.value, this.language)
          } },
        { headerName: this.$t('Pricing.Agent'), field: 'bookingAgent', colId: 'bookingAgent', width: 200,
          cellRenderer: (params) => {
            return this.bookingAgentLabelFunc(params.data, params.value)
          } },
        { headerName: this.$t('Pricing.DepartureDayOfAir'), field: 'frequency8', colId: 'frequency8', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.frequencyLabelFunc(params.data, 'frequency')
          } },
        { headerName: this.$t('Pricing.DepartureDayOfAir2'), field: 'isSecondFrequency', colId: 'isSecondFrequency', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.frequencyLabelFunc(params.data, 'secondFrequency')
          } },
        { headerName: this.$t('Pricing.Days'), field: 'days', colId: 'days', width: 200 },
        { headerName: this.$t('Pricing.CargoAircraft2'), field: 'secondAircraft', colId: 'secondAircraft', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.aircraftLabelFunction(params.value)
          }
        },
        { headerName: this.$t('Pricing.GroupNo'), field: 'groupNo', colId: 'groupNo', width: 200 },
        { headerName: this.$t('Pricing.BeginDateCol'), field: 'beginDate', colId: 'beginDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.EndDateCol'), field: 'endDate', colId: 'endDate', width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          } },
        { headerName: this.$t('Pricing.Branch'), field: 'branchId', colId: 'branchId', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate },
        { headerName: this.$t('Pricing.CreatedBy'), field: 'createdBy', colId: 'createdBy', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate },
        { headerName: this.$t('Pricing.CreatedDate'), field: 'dateCreated', colId: 'dateCreated', width: 200,
          hide: !this.showCreate, suppressColumnsToolPanel: !this.showCreate },
        { headerName: this.$t('Pricing.ModifiedBy'), field: 'modifiedBy', colId: 'modifiedBy', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify },
        { headerName: this.$t('Pricing.ModifiedDate'), field: 'dateModified', colId: 'dateModified', width: 200,
          hide: !this.showModify, suppressColumnsToolPanel: !this.showModify },
        { headerName: this.$t('Pricing.ApprovedBy'), field: 'approvedBy', colId: 'approvedBy', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove },
        { headerName: this.$t('Pricing.ApprovedDate'), field: 'dateApproved', colId: 'dateApproved', width: 200,
          hide: !this.showApprove, suppressColumnsToolPanel: !this.showApprove
        },
        { headerName: this.$t('Pricing.Remarks'), field: 'remarks', colId: 'remarks', width: 200,
          cellRenderer: (params) => {
            return PriceUtils.remarkLabelFunc(params.data, params.value)
          } }],
      subscribe: {
        visible: false
      },
      exportDialog: {
        visible: false
      }
    }
  },
  computed: {
    showMainList() {
      return !this.showDetail
    },
    language() {
      return this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName'
    }
  },
  watch: {
    '$store.getters.currentOfficeId': function() {
      this.toQuery()
    },
    isShowingMoreSearchCondition(newVal) {
      this.$emit('advToggle', newVal)
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    async init() {
      const airConfig = await PricingAirConfigUtil.getInstance()
      this.tenantUtil = await TenantUtil.getInstance()
      if (airConfig._needMarkup) {
        this.showLevel = this.$checkPermission(['PAT']) || this.$checkPermission(['PAA'])
        this.authLevel = this.getAuthLevel()
        this.tiers = PriceUtils.getTiers(airConfig._needMarkup, this.showLevel, this.authLevel)
      } else {
        this.tiers = PriceUtils.getTiers(false, false, 1)
      }
      this.filter.level = (this.tiers && this.tiers.length > 0) ? this.tiers[0].value : ''
    },
    fetchOrderRequirement() {
      this.toQuery()
    },
    toQuery() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery()
      }
    },
    getAuthLevel() {
      if (this.$checkPermission(['PADA_*_0'])) {
        return 0
      } else if (this.$checkPermission(['PADA_*_1'])) {
        return 1
      } else if (this.$checkPermission(['PADA_*_2'])) {
        return 2
      }
      return 99
    },
    // 查询
    toSimpleQuery() {
      const keyWords = this.keyWords ? this.keyWords.trim() : ''
      if (!keyWords || keyWords.length === 0) {
        this.simQueryPlaceholder = ''
        this.$message.warning(this.$t('Pricing.priceNoPrompt'))
        this.$refs.keyword.focus()
        return
      }
      this.fullscreenLoading = getLoading()
      this.proxy = {}
      this.proxy['priceNo'] = keyWords
      this.proxy['isLimited'] = true
      this.proxy['level'] = this.filter.level
      this.proxy['isAdvanced'] = false
      this.proxy['tenantId'] = 0
      queryPriceAirRealSimplePriceNo(this.proxy).then((res) => {
        this.handleQueryData(res)
      })
      this.fullscreenLoading.close()
    },
    handleQueryData(res) {
      const _resMap = res.data
      this.loadingEnd()
      const isNoRecord = !(_resMap)
      if (isNoRecord || _resMap.hasOwnProperty('Count') && Number(_resMap['Count'][0]) === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        this.rowData = []
        return
      }
      const count = Number(_resMap['Count'][0])
      // 只返回部分结果的话，弹窗提醒是否加载更多
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        const msg = StrUtils.substitute(this.$t('Pricing.MaxQueryCount2'), 300)
        this.$confirm(msg, this.$t('Pricing.Tips'), {
          confirmButtonText: this.$t('Pricing.YesLabel'),
          cancelButtonText: this.$t('Pricing.NoLabel'),
          type: 'info',
          closeOnClickModal: false,
          closeOnPressEscape: false,
          showClose: false
        }).then(() => {
        }).catch(() => {
          this.proxy.isLimited = false
          this.toAdvancedQuery(this.proxy)
          return
        })
      }
      let tenantId = NaN
      let rs = []
      for (const item in _resMap) {
        if (item.indexOf('PA') === 0) {
          tenantId = Number(item.substr(2))
          const rs_tenant = _resMap[item]
          if (rs_tenant && rs_tenant.length > 0) {
            PriceUtils.recordTenant(rs_tenant, tenantId)
            rs = rs.concat(rs_tenant)
          }
        }
      }
      if (PriceUtils.isReturnedPartOfResults(this.proxy.isLimited, count)) {
        rs.pop()
      }
      this.rowData = rs
    },
    toAdvancedQuery(data) {
      this.proxy['priceNo'] = ''
      if (!data) {
        this.proxy['isLimited'] = true
      }
      this.proxy['level'] = this.filter.level
      this.proxy['showLevel'] = this.showLevel
      this.proxy['isAdvanced'] = true
      this.proxy['currency'] = this.filter.currency
      this.proxy['pol'] = this.filter.pol
      this.proxy['txtBookingAgent'] = this.filter.txtBookingAgent
      this.proxy['beginDate'] = this.filter.beginDate
      this.proxy['endDate'] = this.filter.endDate
      this.proxy[this.rdoGroupOrg] = this.filter[this.rdoGroupOrg]
      this.proxy[this.rdoGroupDes] = this.filter[this.rdoGroupDes]
      if (this.isManageModule || this.isShowCreatedBy) {
        if (this.filter.cmbCreatedBy === 'createdBy') {
          this.proxy['createdBy'] = this.filter.createdBy
        }
        if (this.filter.cmbCreatedBy === 'branch') {
          this.proxy['branchId'] = this.filter.branch
        }
      }
      if (this.filter.carrier !== 0) {
        this.proxy['carrier'] = this.filter.carrier
      }
      this.fullscreenLoading = getLoading()
      queryPriceAirRealDetail(this.proxy).then((res) =>
        this.handleQueryData(res)
      ).catch(() => {
        this.fullscreenLoading.close()
      })
    },
    loadingEnd() {
      this.gridOptions.api.clearFocusedCell()
      this.txtRemarks = ''
      this.fullscreenLoading.close()
    },
    upOrDownSearchCondition() {
      this.isShowingMoreSearchCondition = !this.isShowingMoreSearchCondition
      this.isAdvancedQuery = this.isShowingMoreSearchCondition
      this.$emit('click-more', this.isShowingMoreSearchCondition)
      this.$emit('update:isSimpleQuery', !this.isShowingMoreSearchCondition)
      // console.log('isShowingMoreSearchCondition', this.isShowingMoreSearchCondition)
    },
    keyWordBlur() {
      this.simQueryPlaceholder = this.$t('Pricing.priceNoPrompt')
    },
    resetSearch() {
      this.filter = PriceUtils.resetFilter(this.filter)
      this.filter.cmbCreatedBy = 'createdBy'
      this.filter.currency = 'USD'
      this.filter.level = '0'
      this.filter.saleState = -1
    },
    onLevelChanged() {
      const { showLevel, filter, authedLevel, targetLevel } = this
      let level = 99
      if (showLevel) {
        level = Number(filter.level)
      } else {
        level = authedLevel
      }
      if (targetLevel !== level) {
        this.targetLevel = level
      }
      this.gridRefresh()
    },
    onQuatotion() {},
    vesselLabel(data) {
      if (data) {
        return '[' + data.shortName + ']' + this.$store.getters.language === 'zh' ? data.chineseName : data.englishName
      }
      return ''
    },
    onSubscribe() {
      this.subscribe.visible = true
    },
    onSubscribeClose() {
      this.subscribe.visible = false
    },
    bookingAgentLabelFunc(data, value) {
      if (value === null) return ''
      const sourcePriceUuid = data.sourcePriceUuid
      if (!StrUtils.isEmpty(sourcePriceUuid)) {
        return this.tenantUtil.getTenantNameById(value)
      } else {
        return ColumnUtils.companyLabelFun(value, this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName', 'cmpIdx')
      }
    },
    onTxtRemarksDoubleClick() {
      console.log('txtRemarks', this.$refs.txtRemark)
      this.$nextTick(() => {
        this.$refs.txtRemark.style.height = !this.remarkChange ? '30%' : '6%'
        this.remarkChange = !this.remarkChange
      })
    },
    onRowClickedEvent(e) {
      const data = e.data
      this.txtRemarks = data.remarks
    },
    gridRefresh() {
      this.gridOptions.api.refreshCells({ force: true })
    },
    changeCurrency(p) {
      this.filter.currency = p.value
      this.gridRefresh()
    },
    exportToExcel() {
      const rows = this.gridOptions.api.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Pricing.NoRecord'))
        return
      }
      this.exportDialog.visible = true
    },
    exportAll() {
      const fileName = PriceUtils.getFileName('PriceAirQuery')
      const rows = this.gridOptions.api.getSelectedRows()
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      exportExcel(fileName, rows, [...allDisplayedColumns], false)
      this.exportDialog.visible = false
    },
    ExportByTemplate() {
      this.fullscreenLoading = getLoading()
      const columnNames = { 'pol': 'POL', 'pod': 'POD', 'via': 'VIA', 'carrier': 'Carrier', 'minCharge': 'MIN', 'step': 'Normal', 'p45': '+45kg', 'p100': '+100kg', 'p300': '+300kg', 'p500': '+500kg', 'p1000': '+1000kg', 'fsc': 'FFC', 'ssc': 'SSC', 'days': 'T/T', 'frequency8': 'Frequency', 'beginDate': 'Valid from', 'endDate': 'Valid Until', 'aircraft': 'AIRCRAFT' }
      // 获取显示列
      const allDisplayedColumns = this.gridOptions.columnApi.getAllDisplayedColumns()
      const exportDatas = []
      const rows = this.gridOptions.api.getSelectedRows()
      const colDef = {}
      allDisplayedColumns.forEach(item => {
        if (columnNames.hasOwnProperty(item.getColId())) {
          colDef[item.getColId()] = item.getColDef()
        }
      })
      rows.map(item => { // 遍历行数据
        const exportData = {}
        const data = item
        for (const dataField in data) { // 遍历每个元素数据
          if (colDef.hasOwnProperty(dataField)) {
            exportData[dataField] = this.getCellData(colDef[dataField], item, dataField)
          }
        }
        exportData['frequency8'] = this.getCellData(colDef['frequency8'], item, 'frequency8')
        exportDatas.push(exportData)
      })
      exportByTemplate(exportDatas, this.filter.currency)
        .then((res) => {
          this.fullscreenLoading.close()
          this.exportDialog.visible = false
          convertResToBlob(res)
        })
        .catch(() => {
          this.fullscreenLoading.close()
        })
    },
    getCellData(colDef, item, dataField) {
      let data = item.hasOwnProperty(dataField) ? item[dataField] : ''
      if (colDef.cellRenderer && typeof colDef.cellRenderer !== 'string') {
        const params = { data: item, value: item[dataField], colDef }
        data = colDef.cellRenderer(params)
      } else if (colDef.valueFormatter && typeof colDef.valueFormatter !== 'string') {
        const params = { data: item, value: item[dataField], colDef }
        data = colDef.valueFormatter(params)
      }
      if (data && typeof data === 'string') {
        data = StrUtils.replaceSpecialCharacter(data)
      }
      return data
    }
  }
}
</script>
<style lang="scss">
</style>

